import U from '../js/utils';

export default async ({elID}) => {
  return new Promise(async (resolve, reject) => {
    try {
      const div = `
      <div id="tableContainer">
        <table id="${elID}Table">
          <thead id="tableHead"></thead>
          <tbody id="tableBody"></tbody>
        </table>
      </div>;
            `;

      const element = U.createHTMLElementFromString(div);
      resolve(element);
    } catch (error) {
      reject(error);
    }
  });
};
